import { Component, Prop, State, h } from '@stencil/core';

import { actionItems, selectedDateItem } from '../types';

import { currentDatePlusSeven, getCalendarEntry } from './utils/calendar';

export interface DateEntry {
  isDisabled?: boolean;
  isStart?: boolean;
  select?: boolean;
  day: number;
  month: number;
  year: number;
}

@Component({
  tag: 'two-weeks-date-select',
  styleUrl: 'two-weeks-date-select.css',
})
export class TwoWeeksDateSelect {
  @Prop() entries: DateEntry[] = [];
  @Prop() expirationDate: string = currentDatePlusSeven();
  @Prop() actions: actionItems = undefined;

  @State() selectedDate: DateEntry = getCalendarEntry(new Date());

  private monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  private weekDays = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

  onDateSelect = (date: selectedDateItem): void => {
    const { day, month, year, isDisabled } = date;

    this.selectedDate = { day, month, year, isDisabled };

    if (this.actions) {
      this.actions.dateChanged({ day, month, year });
    }
  };

  private renderWeekdays = (entry: DateEntry) => {
    const classList = {
      'flex items-center justify-center w-8 aspect-square cursor-pointer rounded-full border-0 text-sm font-open-sans': true,
      'text-clrs-grey text-center cursor-default bg-transparent': entry.isDisabled,
      'bg-clrs-grey hover:shadow-md text-black': entry.isStart,
      'bg-clrs-kbb-darkbrightblue text-clrs-white hover:shadow-md': entry.select,
      'box-border hover:shadow-md hover:border-solid hover:border hover:border-clrs-grey active:border-solid active:border active:border-clrs-grey bg-transparent':
        !entry.select && !entry.isDisabled,
    };

    return (
      <div class="flex items-center justify-center">
        <button class={classList} onClick={() => this.onDateSelect(entry)} disabled={entry.isDisabled}>
          {entry.day}
        </button>
      </div>
    );
  };

  render() {
    return (
      <div class="w-full max-w-md sm:w-80 p-2">
        <header class="flex justify-between items-center">
          <span class="text-black font-bold text-md ml-4 mr-4 grow text-center">
            {this.monthNames[this.selectedDate.month - 1]} {this.selectedDate.year}
          </span>
        </header>
        <div class="grid grid-cols-7 gap-1 mt-2 mb-2 day-header">
          {this.weekDays.map((dayName) => (
            <div class="text-center font-semibold">{dayName}</div>
          ))}
        </div>
        <div class="grid grid-cols-7 gap-1 days">{this.entries.map(this.renderWeekdays)}</div>
        <div class="grid grid-cols-7 gap-1 days"></div>
      </div>
    );
  }
}
